import {Error, ValidationResult, Validator} from '@/type/validation/result';
import {年月書式, 必須入力} from '@/type/validation/validator';
import {在庫集計表出力条件型} from '@/type/custom/keiaikai/stock/在庫集計表出力条件型';

export default class 在庫集計表出力条件チェッカー {
  単項目チェック結果: Error[] = [];

  constructor(出力条件: 在庫集計表出力条件型) {
    const 出力条件チェック = new ValidationResult(在庫集計表出力条件Validators);
    出力条件チェック.validate(出力条件);
    this.単項目チェック結果 = 出力条件チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.map((value) => `${value.message}`);
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => error.name === name);
  }
}

const 対象期間Validator = {
  name: '在庫集計年月',
  constraints: [
    {method: 必須入力, message: '期間を選択してください'},
    {method: 年月書式, message: '期間を正しく入力してください'},
  ],
};

const 在庫集計表出力条件Validators: Validator[] = [
  対象期間Validator,
];


